import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import localeText from "../../../../../locale";

const StepRepresentations = ({ data = {}, onSubmit, onBack, saving }) => {
  const [company_union_representative_rsa, setRsa] = useState(false);
  const [unitary_union_representative_rsu, setRsu] = useState(false);
  const [safety_representative_rps, setRps] = useState(false);
  const [safety_prevention_officer_rspp, setRspp] = useState({ present: false, name: "" });
  const [risk_assessment_document_dvr, setDvr] = useState(false);
  const [interference_risk_assessment_document_duvri, setDuvri] = useState(false);

  useEffect(() => {
    setRsa(!!data.company_union_representative_rsa);
    setRsu(!!data.unitary_union_representative_rsu);
    setRps(!!data.safety_representative_rps);
    setRspp(data.safety_prevention_officer_rspp ?? { present: false, name: "" });
    setDvr(!!data.risk_assessment_document_dvr);
    setDuvri(!!data.interference_risk_assessment_document_duvri);
  }, [data]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      company_union_representative_rsa: company_union_representative_rsa,
      unitary_union_representative_rsu: unitary_union_representative_rsu,
      safety_representative_rps: safety_representative_rps,
      safety_prevention_officer_rspp: {
        present: safety_prevention_officer_rspp.present,
        name: safety_prevention_officer_rspp.present
          ? safety_prevention_officer_rspp.name || null
          : null,
      },
      risk_assessment_document_dvr: risk_assessment_document_dvr,
      interference_risk_assessment_document_duvri: interference_risk_assessment_document_duvri,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-column gap-3">
      <div>
        <h2 className="text-lg font-semibold m-0 mb-2" style={{ color: "var(--theme-text)" }}>
          {localeText("businessDiagnosisStep7Title") || "Rappresentanze"}
        </h2>
        <p className="text-sm m-0 mb-2" style={{ color: "var(--theme-text-muted)" }}>
          {localeText("businessDiagnosisStep7Description") ||
            "Fornisci informazioni sulle eventuali rappresentanze legali o commerciali della tua azienda, sia a livello nazionale che internazionale."}
        </p>
      </div>
      <div className="p-fluid grid" style={{ rowGap: "1rem" }}>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="rsa"
            checked={company_union_representative_rsa}
            onChange={(e) => setRsa(e.checked)}
          />
          <label htmlFor="rsa">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep7RsaLabel") ||
                "RSA - Rappresentante Sindacale Aziendale"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep7RsaHelp") ||
                "Indicare se l'azienda ha un rappresentante sindacale per i soli iscritti al sindacato."}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="rsu"
            checked={unitary_union_representative_rsu}
            onChange={(e) => setRsu(e.checked)}
          />
          <label htmlFor="rsu">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep7RsuLabel") ||
                "RSU - Rappresentante Sindacale Unitario"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep7RsuHelp") ||
                "Segnalare se esiste un rappresentante che tutela tutti i lavoratori, iscritti e non iscritti."}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <Checkbox
            inputId="rps"
            checked={safety_representative_rps}
            onChange={(e) => setRps(e.checked)}
          />
          <label htmlFor="rps">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep7RpsLabel") ||
                "RPS - Rappresentante per la Sicurezza"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep7RpsHelp") ||
                "Specificare se i lavoratori hanno nominato un rappresentante per la sicurezza."}
            </div>
          </label>
        </div>
        <div className="col-12 md:col-6 flex gap-2">
          <div className="flex gap-2 mb-1">
            <Checkbox
              inputId="rspp"
              checked={safety_prevention_officer_rspp.present}
              onChange={(e) => setRspp((p) => ({ ...p, present: e.checked }))}
            />
            <label htmlFor="rspp">
              <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
                {localeText("businessDiagnosisStep7RsppLabel") ||
                  "RSPP - Rappresentante per la Sicurezza e Prevenzione"}
              </div>
              <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
                {localeText("businessDiagnosisStep7RsppHelp") ||
                  "Indicare se il datore di lavoro ha nominato un responsabile per la sicurezza e prevenzione."}
              </div>
            </label>
          </div>
        </div>
        {safety_prevention_officer_rspp.present && (
          <div className="col-12">
            <label className="block text-sm mb-1">
              {localeText("businessDiagnosisStep7RsppNameLabel") || "RSPP indicare nominativo"}
            </label>
            <InputText
              value={safety_prevention_officer_rspp.name}
              onChange={(e) => setRspp((p) => ({ ...p, name: e.target.value }))}
              className="w-full border-round-md p-no-outline"
              placeholder={
                localeText("businessDiagnosisStep7RsppNamePlaceholder") ||
                "Scrivere il nome della persona nominata come RSPP."
              }
            />
          </div>
        )}
        <div className="col-12 flex align-items-start gap-2">
          <Checkbox
            inputId="dvr"
            checked={risk_assessment_document_dvr}
            onChange={(e) => setDvr(e.checked)}
          />
          <label htmlFor="dvr">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep7DvrLabel") ||
                "DVR - Documento di Valutazione dei Rischi"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep7DvrHelp") ||
                "Documento di valutazione dei rischi."}
            </div>
          </label>
        </div>
        <div className="col-12 flex align-items-start gap-2">
          <Checkbox
            inputId="duvri"
            checked={interference_risk_assessment_document_duvri}
            onChange={(e) => setDuvri(e.checked)}
          />
          <label htmlFor="duvri">
            <div className="font-medium text-sm" style={{ color: "var(--theme-text)" }}>
              {localeText("businessDiagnosisStep7DuvriLabel") ||
                "DUVRI - Documento Unico di Valutazione dei Rischi da Interferenze"}
            </div>
            <div className="text-xs" style={{ color: "var(--theme-text-muted)" }}>
              {localeText("businessDiagnosisStep7DuvriHelp") ||
                "Indicare se è presente il documento che valuta i rischi derivanti da attività di terzi in azienda."}
            </div>
          </label>
        </div>
      </div>
      <div className="flex gap-2 flex-wrap mt-2 justify-content-end">
        {onBack && (
          <Button
            type="button"
            label={localeText("back") || "Indietro"}
            className="p-button-text"
            style={{ color: "var(--theme-primary)" }}
            onClick={onBack}
            disabled={saving}
          />
        )}
        <Button
          type="submit"
          loading={saving}
          disabled={saving}
          className="border-round-md flex align-items-center gap-2 py-3 px-3"
        >
          <span className="text-sm text-white font-medium">{localeText("saveAndContinue")}</span>
          <i className="pi pi-arrow-right text-white text-xs"></i>
        </Button>
      </div>
    </form>
  );
};

export default StepRepresentations;
